<app-breadcrumb master="Administracja" parentName="Szablony" name="Lista pól"></app-breadcrumb>
<div class="templating-config-container" *ngIf="templatingConfig">
  <div fxLayout="column">
    <div>
      <h3>Przykłady użycia</h3>
      <p>*.docx, *.xlsx: {{'${Partner.Pełna nazwa}'}}</p>
      <p>*.pdf: {{'Partner.Pełna nazwa'}}</p>
    </div>
  </div>

  <div fxLayout="row">
    <mat-tab-group>
      <ng-container *ngFor="let type of templatingConfig.config.types">
        <mat-tab [label]="type.displayName">
          <div fxLayout="column" style="padding: 15px">
            <ng-container *ngFor="let configMap of configMaps[type.fieldsConfig]">
              <app-templating-config-fields fxFlex="100" [configMap]="configMap" [rootPrefix]="type.displayName"></app-templating-config-fields>
            </ng-container>
          </div>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </div>

</div>
